import React from "react";
import tem1 from "../../../assets/images/tem1.png";
import tem2 from "../../../assets/images/tem2.png";
import tem3 from "../../../assets/images/tem3.png";
import star from "../../../assets/images/star.png";
import Slider from "react-slick";
import "./index.scss";
import { Image } from "react-bootstrap";
export const Temoignage = () => {
  const temoignage = [
    {
      name: "Mme D.,Colombes",
      description:
        "Isolation parfaite et chantier propre. Je recommande cette entreprise sans hésiter !",
      role: "particulier",
      image: tem1,
    },
    {
      name: "Copropriété,",
      description:
        "Ravalement à la chaux impeccable, rendu magnifique. Équipe sérieuse et réactive.",
      role: "Suresnes",
      image: tem2,
    },
    {
      name: "Mme D.,Colombes",
      description:
        "Isolation parfaite et chantier propre. Je recommande cette entreprise sans hésiter !",
      role: "particulier",
      image: tem3,
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 500,
    arrows: false, // Direction de droite à gauche
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1500, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 3, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 2, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 1, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="temoignage">
      <div className="temoignge-container">
        <div className="temoignage-header">
          <div className="temoignage-title">
            Ce que nos clients disent de nous
          </div>
          <div className="temoignage-subtitle mt-3">
            Des avis sincères qui reflètent notre engagement et la qualité de
            nos services.{" "}
          </div>
        </div>
        <Slider {...settings} className="mt-5">
          {temoignage.map((member, index) => (
            <div className="testimonial-card ">
              <div className=" d-flex align-items-center mb-3  gap-4">
                <Image
                  src={member?.image}
                  alt={member.name}
                  roundedCircle
                  className="avatar"
                />

                <div>
                  <h4 className="mb-1 ">{member.name}</h4>
                  <h3 className=" ">{member.role}</h3>
                </div>
              </div>
              <p className="mb-0 ">{member.description}</p>
              <img src={star} alt="" className="img-fluid mt-3" />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
